// US2003003's Rally acceptance criteria specify a 5s max timeout. Raised to 15s deliberately after
// observing real-world PAT API latency exceed 5s under normal load in testing - 5s was triggering
// false-positive timeouts. Revisit if PAT API latency improves.
export const PAT_ELIGIBILITY_TIMEOUT_MS = 15000

export function withTimeout(promise, timeoutMs = PAT_ELIGIBILITY_TIMEOUT_MS) {
    let timer
    const timeout = new Promise((resolve, reject) => {
        timer = setTimeout(() => {
            reject(new Error('PAT_ELIGIBILITY_TIMEOUT'))
        }, timeoutMs)
    })

    return Promise.race([promise, timeout]).finally(() => clearTimeout(timer))
}
